module.exports = __webpack_public_path__ + "img/lunchly_menu4.68c2bb6c.png";